<template>
  <div class="operation-bd" v-if="funcView.operations_list || funcView.schedules_list">
    <div class="tab-box">
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-tabs v-model="statusState">
          <el-tab-pane :label="$t('operation.bao_gao_ji_lu')" name="operations" v-if="funcView.operations_list"></el-tab-pane>
          <el-tab-pane :label="$t('operation.tui_song_ji_hua')" name="schedules" v-if="funcView.schedules_list"></el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
    <operations v-if="statusState === 'operations'"></operations>
    <schedules v-if="statusState === 'schedules'"></schedules>
  </div>
</template>

<script>
// import apis from '@/utils/apis';
import operations from './children/operations.vue';
import schedules from './children/schedules.vue';

export default {
  name: 'operation',
  mixins: [],
  components: { operations, schedules },
  data() {
    return {
      provide: true,
      tableSelect: [],
      statusState: '',

      formSearch: {
        protocolCode: '',
        search: '',
        operationsState: null,
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        imsi: '',
        tcpVersion: '',
        batteryCharge: [],
        dataTimes: [],
        websiteName: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  activated: function () {
    // this.getTableList();
  },
  mounted: function () {
    this.getFuncView(null, () => {
      if (this.funcView.operations_list) {
        this.statusState = 'operations';
      } else if (this.funcView.schedules_list) {
        this.statusState = 'schedules';
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.operation-bd {
  padding: 24px;
  .tab-box {
    .form-screen {
      overflow: hidden;
      line-height: 40px;
    }
  }
  .stock-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
  .search-hd {
    margin-top: 16px;
    padding: 24px;
    background: #ffffff;
    border-radius: 16px;
    .form-screen {
      .el-form-item {
        margin-bottom: 0;
      }
      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }
  }
  .table-card {
    margin-top: 16px;
    padding: 24px 24px 0;
    background: #ffffff;
    border-radius: 16px;
    .table-bd {
      height: 450px;
    }
    .table-footer {
      height: 88px;
    }
  }
}
</style>
